export default {
    settings: {
        lang: {
            id: 1
        }
    },
    user: {},
    emptyObj: {},
    emptyArr: [],
    playersList: {
        list: [],
        listModalVisible: false,
        isLoading: false
    },
    allowCancel: {
        allowBets: false,
        allowTransaction: false
    },
    cards: new Array(6).fill(undefined),
    timer:{
        timerStart: undefined,
        timerEnd: undefined
    },
    gameInfo: {
        roundId: ""
    }
}